import {Component, EventEmitter, input, output} from '@angular/core';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';

@Component({
  selector: 'back-button',
  imports: [],
  templateUrl: './back-button.html',
  styleUrl: './back-button.scss',
})
export class BackButton {
  public coursesId?: string;
  public routerLink = input<string| null>('');

  constructor(private activeRoute:ActivatedRoute,private router:Router ) {
    this.coursesId = this.activeRoute.snapshot.parent?.paramMap.get('coursesId')!;

  }

  public rout() {
    const link = this.routerLink();
    if (link && link.length > 0) {
      this.router.navigate([link]);
    }else if (this.coursesId) {
      this.router.navigate([this.coursesId]);
    }
  }
}
